import React from 'react';

import { getShortenedEmail } from '@app/helpers/common';
import { getUserAvatar } from '@app/helpers/urls';
import { type User } from '@app/types/api/user';
import { Avatar } from '@chakra-snippets/avatar';

import AvatarListItem from './avatar-list-item';

interface UserRowProps {
  option: User;
  size?: 'xs' | 'sm' | 'md';
  showTitle?: boolean;
  isYou?: boolean;
  boldName?: boolean;
  borderRadius?: string;
  showEmail?: boolean;
  userNameFontWeight?: string;
  rightElement?: React.ReactNode;
}

const UserRow: React.FC<UserRowProps> = ({
  option,
  size = 'md',
  showTitle = false,
  isYou = false,
  boldName = false,
  borderRadius,
  showEmail = false,
  userNameFontWeight,
  rightElement,
}) => {
  let name = option.label || option.name || `${option.firstName} ${option.lastName}`;
  if (isYou) {
    name = `${name} (Me)`;
  }
  if (option?.archived) {
    name = `${name} (Deactivated)`;
  }

  const subtitles = [];
  if (showEmail && option.email) {
    subtitles.push(getShortenedEmail(option.email));
  }
  if (showTitle && option.title) {
    subtitles.push(option.title);
  }

  return (
    <AvatarListItem
      avatar={(
        <Avatar
          size={size}
          id={option.id}
          src={getUserAvatar(option)}
          name={(option.name || option.label || `${option.firstName} ${option.lastName}`).replace('Assign to', '').replace('(me)', '').trim()}
          borderRadius={borderRadius || (size === 'md' ? 'md' : 'full')}
          bg="marleyRed.500"
          color="white"
        />
      )}
      name={name}
      subtitles={subtitles}
      showSubtitle={showTitle || showEmail}
      size={size}
      rightElement={rightElement}
      boldName={boldName}
      nameFontWeight={userNameFontWeight}
    />
  );
};

export default UserRow;
